export default __webpack_public_path__ + "static/377-7073e5fed0e36d4780acbc7d86e09d4c.gif";